/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { CreateSberPayPaymentMutationRequest, CreateSberPayPaymentMutationResponse, CreateSberPayPayment400, CreateSberPayPayment401, CreateSberPayPayment404, CreateSberPayPayment500 } from "../entities/CreateSberPayPayment";

function getCreateSberPayPaymentUrl() {
  const res = { method: 'POST', url: `/api/v1/payments/sberpay` as const }
  return res
}

/**
 * @description Создает новый платеж через платежную систему SberPay.
 * **Требования:**
 * - Аутентификация по заголовкам `user-id` и `city-id`
 * - Минимальная сумма платежа: 240 рублей (24000 копеек)
 * - Максимальная сумма платежа: 9000 рублей (900000 копеек)
 * - ОС устройства пользователя: android, ios
 * - URL для возврата пользователя после оплаты c виджета SberPay
 * **Процесс:**
 * 1. Валидация входных данных
 * 1.1. Проверка, что сумма платежа находится в допустимом диапазоне
 * 1.2. Проверка, что ОС устройства пользователя является допустимой
 * 1.3. Проверка, что URL для возврата пользователя после оплаты c виджета SberPay является допустимым (не пустой строкой)
 * 2. Создание записи в БД
 * 3. Создание платежа в СберПей
 * 4. Возврат ответ с идентификатором заказа в системе СберПей и URL для возврата пользователя после оплаты c виджета SberPay
 * @summary Инициализация платежа через SberPay
 * {@link /api/v1/payments/sberpay}
 */
export async function createSberPayPayment(data: CreateSberPayPaymentMutationRequest, config: Partial<RequestConfig<CreateSberPayPaymentMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<CreateSberPayPaymentMutationResponse, ResponseErrorConfig<CreateSberPayPayment400 | CreateSberPayPayment401 | CreateSberPayPayment404 | CreateSberPayPayment500>, CreateSberPayPaymentMutationRequest>({ method : "POST", url : getCreateSberPayPaymentUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}